import React, { useEffect, useState } from "react";
import { notifyError, notifyErrorInBottom, notifySuccess } from "../../helper";
import { useParams } from "react-router-dom";
import client from '../../api';
import LeadCondition from "./LeadCondition";

const LeadSettingBox = () => {
    const {campaignID} = useParams('');
    const api = client();
    const [loading,setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [leadsSettings,setLeadsSettings] = useState();
    const [errors,setErrors] = useState([]);
    
    const handleClauseChange = () => {
        if(leadsSettings?.leads?.clause === 'and'){
            setLeadsSettings({...leadsSettings,leads:{...leadsSettings.leads,'clause':'or'}});
        } 
        if(leadsSettings?.leads?.clause === 'or'){
            setLeadsSettings({...leadsSettings,leads:{...leadsSettings.leads,'clause':'and'}});
        }
    }

    const handleFieldChange = (obj) => {
        setLeadsSettings({...leadsSettings,"leads":{...leadsSettings.leads,...obj}});
    }

    const addLeadConditions = () => {
        let initialRule = { 
            "type": "replies",
            "event_count": 1
        }
        setLeadsSettings({...leadsSettings,leads:{...leadsSettings.leads,'conditions':[...leadsSettings.leads.conditions,initialRule]}});
        setErrors([...errors,{message:''}]);
    }

    const removeLeadCondition = (dataId) => {
        const updatedLeads = (leadsSettings?.leads?.conditions).filter((row,i)=>(i !== dataId));
        setLeadsSettings({...leadsSettings,leads:{...leadsSettings.leads,'conditions':[...updatedLeads]}});

        const removeErrorBlock = (errors).filter((row,i)=>(i !== dataId));
        setErrors([...removeErrorBlock]);
    }
    const handleLeadsFieldChange = (dataId) => {
        return (e) => {
            const UpdatedData = (leadsSettings?.leads?.conditions).map((row, i)=>{
                if(dataId === i){
                    if(e.target.name === 'event_count'){
                        row[e.target.name] = (e.target.value).length ? parseInt(e.target.value):'';
                    } else {
                        row[e.target.name] = e.target.value;
                    }
                        
                }
                return row;
            });
            setLeadsSettings({...leadsSettings,leads:{...leadsSettings.leads,'conditions':[...UpdatedData]}});
        }
    }
    const validateData = () => {
        let errorExists = errors.filter((row,i)=>(row.message.length));
        return !errorExists.length;
    }
    const saveLeadSettings = async () => {
        try{
            setLoading(true);
            if(validateData()){
                const payload = {...leadsSettings,campaign_id: campaignID}
                if (payload.hasOwnProperty("campaignID")) {
                    delete payload['campaignID'];
                }                
                const response = await api.post('/v1/campaign/settingLeads/update',payload);
                if(response.status === 200 || response.status === 201){
                    setLoading(false);
                    notifySuccess('Lead Settings updated successfully');
                }
            } else {
                notifyErrorInBottom('Please resolve all validation errors.');
                setLoading(false);
            }
        } catch(error){
            setLoading(false);
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Unable to update Lead settings. Please try again.');
        }
    }

    useEffect(()=>{
        const getUsers = async () => {
            try{
                const response = await api.get('/v1/user/list');
                if(response.status === 200 || response.status === 201){
                    setUsers(response.data.users_list);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Unable to fetch mail accounts. Please try again');
            }

        }
        getUsers();
    },[]);

    useEffect(()=>{
        const getleadsSettingsData = async () => {
            try{
                const payload = {
                    campaignID:campaignID
                }
                const response = await api.post('/v1/campaign/settingLeads/get',payload);
                if(response.status === 200 || response.status === 201){
                    const data = response.data.data;
                    let initialError = (data.leads.conditions).map((row,i)=>({message:''}));
                    setErrors([...initialError]);
                    setLeadsSettings(data);                    
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Unable to fetch mail accounts. Please try again');
            }

        }
        getleadsSettingsData();
    },[]);
    
    return(
        <div className="box">
            <div className="box-title">Leads</div>
            <div className="box-form">
                <div className="field-wrap">
                    <label className="label-xs">Who should leads to assign to?</label>
                    <select className="selectbox" value={leadsSettings?.leads?.assigned_to} onChange={(e)=>{handleFieldChange({'assigned_to':e.target.value})}}>
                        {users.map((row,i)=>(<option key={i} value={row._id}>{row.name} - ({row.email})</option>))}
                    </select>
                </div>
                <div className="column-2">
                    <label className="label">When does a recipient become a lead?</label>
                    {(leadsSettings?.leads?.conditions) && (leadsSettings?.leads?.conditions).map((condition,index)=>(<LeadCondition 
                        key={index} 
                        condition={condition} 
                        index={index} 
                        clause={leadsSettings?.leads?.clause}
                        removeLeadCondition={removeLeadCondition} 
                        handleClauseChange={handleClauseChange}
                        handleLeadsFieldChange={handleLeadsFieldChange}
                        setErrors={setErrors}
                        errors={errors}
                        />))}
                </div>
                <div className="box-link">
                    <span className="other-conditions" onClick={()=>{
                        addLeadConditions()
                    }}>+ Add another condition</span>
                </div>
            </div>
            <div className="box-action">
                <button 
                    className={loading ? "primary-btn button--loading":"primary-btn"} 
                    disabled={loading}
                    onClick={()=>{
                        saveLeadSettings()
                    }}>
                        <span className="button--text">Save</span>                        
                </button>
            </div>
        </div>
    );
}

export default LeadSettingBox;